import { Link } from "react-router-dom";
import type { Clip } from "@/utils/catalog";
import { formatDuration, formatViews } from "@/utils/catalog";

interface ClipCardProps {
  clip: Clip;
}

export default function ClipCard({ clip }: ClipCardProps) {
  return (
    <Link
      to={`/detail/clip/${clip.id}`}
      className="group block overflow-hidden rounded-lg border border-background-200/70 bg-background-50 transition hover:border-primary-300"
    >
      <div className="relative w-full aspect-[16/9] overflow-hidden bg-background-100">
        <img
          src={clip.thumbnail}
          alt={`${clip.title}缩略图`}
          title={`${clip.title} 精彩片段`}
          className="h-full w-full object-cover object-top transition duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 flex items-center justify-center bg-foreground-950/20 opacity-0 transition group-hover:opacity-100">
          <span className="flex h-12 w-12 items-center justify-center rounded-full bg-background-50/90 text-primary-600">
            <i className="ri-play-fill text-2xl"></i>
          </span>
        </div>
        <span className="absolute bottom-3 right-3 rounded bg-foreground-950/70 px-2 py-0.5 text-[11px] text-background-50">
          {formatDuration(clip.duration)}
        </span>
        <span className="absolute left-3 top-3 rounded-full bg-background-50/90 px-2.5 py-0.5 text-[11px] text-accent-800">
          {clip.type}
        </span>
      </div>
      <div className="p-4">
        <h3 className="line-clamp-2 text-sm font-medium leading-snug text-foreground-900 transition group-hover:text-primary-600">
          {clip.title}
        </h3>
        <div className="mt-2 flex items-center gap-3 text-[11px] text-foreground-400">
          <span className="flex items-center gap-1">
            <i className="ri-play-circle-line"></i>
            {formatViews(clip.views)} 次播放
          </span>
        </div>
      </div>
    </Link>
  );
}